import { render, staticRenderFns } from "./BodyDeAdiantamentos.vue?vue&type=template&id=52654aa5&scoped=true"
import script from "./BodyDeAdiantamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeAdiantamentos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeAdiantamentos.vue?vue&type=style&index=0&id=52654aa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52654aa5",
  null
  
)

export default component.exports